import type { PickListDesignTokens, PickListTokenSections } from '@primeuix/themes/types/picklist';

export const root: PickListTokenSections.Root = {
    gap: '1.125rem'
};

export const controls: PickListTokenSections.Controls = {
    gap: '0.5rem'
};

export const css: PickListTokenSections.CSS = ``;

export default {
    root,
    controls,
    css
} satisfies PickListDesignTokens;
